import React from 'react';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';

import NewInput from 'components/atoms/NewInput';
import MbRadioGroup from 'components/molecules/MbRadioGroup';
import Modal from 'components/organisms/NewModal';
import FilterCollection from 'components/organisms/FilterCollection';

const ScriptModal = (props) => {
  const { t } = useTranslation();
  const {
    modal,
    handleClose,
    handleSubmit,
    pageType,
    getParams,
    getModalParam,
    userList,
    duplicate,
    solution,
    error,
    loading,
  } = props;

  return (
    <Modal
      open={modal['open']}
      headerTitle={modal['headerTitle']}
      confirmBtnTitle={modal['confirmBtnTitle']}
      confirmBtnOpen
      useForm={pageType === 'add' || pageType === 'modify'}
      handleClose={handleClose}
      confirmOnClick={handleSubmit}
      loading={loading}
    >
      {pageType === 'delete' ? (
        t('삭제하시겠습니까?')
      ) : (
        <>
          {modal['params']['solution'] !== '96' && (
            <tr>
              <th>{t('긴급')}</th>
              <td>
                <MbRadioGroup
                  radioList={[
                    { label: t('일반'), value: '01' },
                    { label: t('긴급'), value: '02' },
                  ]}
                  selectedValue={modal['params']['state']}
                  onChange={getParams}
                  name="state"
                />
              </td>
            </tr>
          )}
          <tr>
            <th>{t('솔루션')}</th>
            <td>
              <FilterCollection
                label={t('솔루션')}
                name="solution"
                params={modal['params']}
                value={modal['params']['solution']}
                type="select"
                list={solution}
                callBack={getModalParam}
                labelKey="CODE_DESC"
                valueKey="CODE_ID"
                error={error['solution']}
              />
            </td>
          </tr>
          <tr>
            <th>{t('담당자')}</th>
            <td>
              <FilterCollection
                label={t('담당자')}
                name="manager"
                params={modal['params']}
                value={modal['params']['manager']}
                type="select"
                list={userList}
                callBack={getModalParam}
                labelKey="USER_NAME"
                valueKey="USER_ID"
                error={error['manager']}
              />
            </td>
          </tr>
          <tr>
            <th>{t('타이틀')}</th>
            <td>
              <NewInput
                type="filter"
                name="title"
                params={modal['params']}
                value={modal['params']['title']}
                callBack={getModalParam}
                style={{ width: 400 }}
                error={error['title']}
              />
            </td>
          </tr>
          {modal['params']['solution'] !== '96' && (
            <tr>
              <th>{t('광고주ID')}</th>
              <td>
                <div style={{ display: 'flex' }}>
                  <NewInput
                    type="filter"
                    name="adverId"
                    params={modal['params']}
                    value={modal['params']['adverId']}
                    callBack={getModalParam}
                    style={{ width: 400, marginRight: 10 }}
                  />
                </div>
                {duplicate && (
                  <p style={{ margin: 0, color: 'red' }}>
                    * 중복된 데이터가 있습니다.
                  </p>
                )}
              </td>
            </tr>
          )}
          {modal['params']['solution'] !== '99' &&
            modal['params']['solution'] !== '96' && (
              <tr>
                <th>{t('타입')}</th>
                <td>
                  <MbRadioGroup
                    radioList={[
                      { label: t('미선택'), value: 'all' },
                      { label: t('스크립트'), value: '01' },
                      { label: t('인사이트'), value: '02' },
                      { label: t('스크립트+인사이트'), value: '03' },
                    ]}
                    selectedValue={modal['params']['type']}
                    onChange={getParams}
                    name="type"
                  />
                </td>
              </tr>
            )}
          {modal['params']['solution'] !== '96' && (
            <tr>
              <th>{t('트렐로')}</th>
              <td>
                <NewInput
                  type="filter"
                  name="trelloLink"
                  params={modal['params']}
                  value={modal['params']['trelloLink']}
                  callBack={getModalParam}
                  style={{ width: 400 }}
                />
              </td>
            </tr>
          )}
          <tr>
            <th>{t('추가 점수')}</th>
            <td>
              <NewInput
                type="filter"
                name="extraPoints"
                params={modal['params']}
                value={modal['params']['extraPoints']}
                callBack={getModalParam}
                style={{ width: 400 }}
              />
            </td>
          </tr>
        </>
      )}
    </Modal>
  );
};

export default withRouter(ScriptModal);
